import { render } from "./ProjectDetail.vue?vue&type=template&id=2d3b5b9f&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=2d3b5b9f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3b5b9f"],['__file',"src/views/h5/crm/project/manage/ProjectDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d3b5b9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d3b5b9f', __exports__)) {
    api.reload('2d3b5b9f', __exports__)
  }
  
  module.hot.accept("./ProjectDetail.vue?vue&type=template&id=2d3b5b9f&scoped=true", () => {
    api.rerender('2d3b5b9f', render)
  })

}


export default __exports__